// Desc: API Endpoints for the application

//Bookings reports
export const buyerBookingsReportEndpoints = Object.freeze({
  search: "/api/booking/buyers",
});

export const supplierBookingsReportEndpoints = Object.freeze({
  search: "/api/booking/suppliers",
  report: "/api/booking/suppliers/report",
});

//Invoice Reports
export const adminInvoicesReportEndpoints = Object.freeze({
  search: "/api/admins/report/invoices",
  report: "/api/admins/report/invoices/report",
  summary: "/api/admins/report/invoices/summary",
  group: "/api/admins/report/invoices/group-summary-report",
});

export const buyerInventoryReportEndpoints = Object.freeze({
  search: "/api/inventory/buyers",
  report: "/api/inventory/buyers/report",
});

export const buyerInventoryCorrectionReport = Object.freeze({
  search: "/api/buyers/inventory-correction-report",
});

export const buyerInvoicesReportEndpoints = Object.freeze({
  search: "/api/invoices/buyers",
  report: "/api/invoices/buyers/report",
  summary: "/api/invoices/buyers/summary",
});

export const supplierInvoicesReportEndpoints = Object.freeze({
  search: "/api/invoices/suppliers",
  report: "/api/invoices/suppliers/report",
});

export const buyerInterchangesReportEndpoints = Object.freeze({
  search: "/api/inventory-activity/buyers",
  report: "/api/inventory-activity/buyers/report",
  summaryReport: "/api/inventory-activity/buyers/summary-report",
});

// Space Usage Reports
export const buyerSpaceUsageReportEndpoints = Object.freeze({
  search: "/api/space-usage/buyers",
  report: "/api/space-usage/buyers/report",
  summary: "/api/space-usage/buyers/summary",
  group: "/api/space-usage/buyers/group-summary-report",
});

export const supplierSpaceUsageReportEndpoints = Object.freeze({
  search: "/api/space-usage/supplier",
  report: "/api/space-usage/supplier/report",
  group: "/api/space-usage/supplier/group-summary-report",
});

export const accountRegistrationEndpoints = Object.freeze({
  verifyEmail: "/api/account/verification-email/verify",
  resendVerification: "/api/account/resend-verification",
  resetPassword: "/api/account/reset-password",
  changePassword: "/api/account/change-password",
});

export const accountEditEndpoints = Object.freeze({
  accountUser: {
    get: (accountId) => `/api/account-users/${accountId}`,
    create: "/api/account-users",
    update: "/api/account-users",
    remove: "/api/account-users/",
  },
  account: {
    create: "/api/account",
    update: "/api/account",
  },
  fundingSources: {
    create: '/api/account/funding-sources',
    remove: (accountId) => `/api/account/${accountId}/funding-sources`,
  },
  cognitoToken: (accountId) => `/api/account/${accountId}/cognito/token`,
  conformToS: (accountId) => `/api/account/confirm-tos/${accountId}`,
  updateUserAccessibleLocations: (accountId) => `/api/account-users/${accountId}`,
  verificationEmail: "/api/account/verification-email",
});

export const bookingRequests = Object.freeze({
  allBuyerBookings: "/api/booking/all-buyer-bookings",
  completeBooking: "/api/booking/complete-booking",
  buyerPendingBookings: "/api/booking/buyer-pending-count",
  supplierPendingBookings: "/api/booking/count-bookings",
  updateBookingPaymentMethod: "/api/booking/update-payment-method",
  updateBookingStatus: {
     approve: '/api/booking/approve',
     decline: '/api/booking/decline',
   },
});

export const bookingTransactionRequests = Object.freeze({
  failedBookingTransactions: (bookingId) => `/api/booking/${bookingId}/transactions/failed`,
  failedBookingTransactionsRetry: (bookingId) => `/api/booking/${bookingId}/transactions/failed/retry`
});

export const citiesRequests = Object.freeze({
  search: "/api/cities",
});